// Libraries
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import { ReactElement } from 'react';
// Components
import { DialogerTypesKeys } from '@hooks/index';
//Data
import { DialogerStore } from '@stores/index';

/**
 * Props for the Dialoger component.
 */
export type DialogerProps = Omit<DialogerStore, 'onOpen' | 'setSetup'> & {
  /**
   * Specifies the type of dialog component, either 'drawer' or 'modal'.
   */
  dialogerType: DialogerTypesKeys;
};

/**
 * Mapping of dialog component types to their corresponding Chakra UI components.
 */
export const ComponentsMap = {
  /**
   * Chakra UI components for a modal dialog.
   */
  modal: {
    Component: Modal,
    OverlayComponent: ModalOverlay,
    HeaderComponent: ModalHeader,
    ContentComponent: ModalContent,
    BodyComponent: ModalBody,
    CloseButtonComponent: ModalCloseButton,
  },
  /**
   * Chakra UI components for a drawer dialog.
   */
  drawer: {
    Component: Drawer,
    OverlayComponent: DrawerOverlay,
    HeaderComponent: DrawerHeader,
    ContentComponent: DrawerContent,
    BodyComponent: DrawerBody,
    CloseButtonComponent: DrawerCloseButton,
  },
};

/**
 * Props for the DialogerHeader component.
 */
export type DialogerHeaderProps = {
  /**
   * Closes the dialoger.
   */
  onClose: () => void;
  /**
   * Element to display as header.
   */
  children: ReactElement;
};
